import moment from 'moment'
import PropTypes from 'prop-types'

import FilterTag from './FilterTag'

const DATE_FORMAT = 'M/DD/YYYY'

const CustomDateFilterTag = ({ oldest, latest, onClose }: any) => {
  const oldestFormatted = moment(oldest).format(DATE_FORMAT)
  const latestFormatted = moment(latest).format(DATE_FORMAT)
  return <FilterTag onClose={onClose} textAsString={`${oldestFormatted} - ${latestFormatted}`} />
}

CustomDateFilterTag.displayName = 'CustomDateFilterTag'

CustomDateFilterTag.propTypes = {
  oldest: PropTypes.string.isRequired,
  latest: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired
}

export default CustomDateFilterTag
